import { render, staticRenderFns } from "./QuizComponent.vue?vue&type=template&id=406c3d52&scoped=true&"
import script from "./QuizComponent.vue?vue&type=script&lang=js&"
export * from "./QuizComponent.vue?vue&type=script&lang=js&"
import style0 from "./QuizComponent.vue?vue&type=style&index=0&id=406c3d52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "406c3d52",
  null
  
)

export default component.exports